import React, { useState } from "react";
import { useSelector } from "react-redux";

export default function RadioButton({
  theme,
  id,
  className,
  label,
  isFocus,
  isEnabled,
  isChecked,
  onClick = () => {},
}) {
  const focusNameList = useSelector((state) => state.element.focusNameList);
  // const focusIndex = useSelector((state) => state.element.focusIndex);
  const [hasFocus, setHasFocus] = useState(false); // 👈 focus 狀態

  const radio = () => {
    let css = "border-[1.5px] rounded-full flex items-center justify-center ";
    css += ` group-hover:bg-${theme}-input-focus group-hover:border-${theme}-radio `;
    // const tick = theme === "light" ? "bg-white-tick" : "bg-dark-tick";

    const idx = focusNameList.findIndex((item) => item === id);
    // const isFocusedByRedux = idx === focusIndex && isFocus;

    if (hasFocus) {
      css += ` border-${theme}-radio bg-${theme}-input-focus bg-opacity-50 `;
      // css += ` rounded-full border-[3px] `;
      // if (isChecked) {
      //   css += ` ${tick} bg-cover bg-${theme}-input-focus bg-opacity-80`;
      // }
    } else {
      css += ` border-${theme}-radio `;
    }

    return css;
  };

  const handleClick = (e) => {
    e.stopPropagation();
    onClick(id);
  };

  return (
    <div
      data-id={id}
      id={id}
      className={className + " group "} // 👈 focus class
      onClick={handleClick}
      onFocus={() => setHasFocus(true)} // 👈 focus 狀態進入
      onBlur={() => setHasFocus(false)} // 👈 focus 狀態離開
      aria-label={label}
      aria-checked={isChecked}
      role="radio"
      aria-roledescription={`Radio Button`}
      tabIndex={0} // 👈 讓 div 可聚焦（很重要）
    >
      <input
        type="radio"
        name="feedback"
        className="hidden peer"
        checked={isChecked}
        readOnly
      />
      <div
        className={`w-7 h-7 mr-3 flex items-center justify-center ${radio()}`}
      >
        {isChecked && (
          <div
            className={`w-5 h-5 items-center bg-${theme}-checked  rounded-full`}
          ></div>
        )}
      </div>
      <label
        className={`text ${
          isEnabled ? `text-${theme}-normal` : `text-${theme}-disabled`
        }`}
        aria-label={label}
        aria-roledescription={"input"}
        aria-hidden={"true"}
      >
        {label}
      </label>
    </div>
  );
}
